import styled from 'styled-components';

const AddressDisplay = styled.div`
  font-size: 13px;
`;

type OneTimeAddressDisplayProps = {
  address: {
    businessName?: string;
    attention: string;
    address: {
      address1: string;
      address2?: string;
      city: string;
      state?: {
        abbr: string;
      };
      postalCode?: string;
    };
  };
};

const OneTimeAddressDisplay = ({ address }: OneTimeAddressDisplayProps) => {
  return (
    <AddressDisplay>
      {address.businessName && (
        <>
          <b>{address.businessName}</b>
          <br />
        </>
      )}
      <b>{`${address.attention}`}</b>
      <br />
      {address.address.address1}
      <br />
      {address.address.address2 && (
        <>
          {address.address.address2}
          <br />
        </>
      )}
      <p>
        {address.address.city}
        {address.address.state && (
          <>
            ,&nbsp;
            {address.address.state.abbr}
          </>
        )}
        {address.address.postalCode && <>&nbsp;{address.address.postalCode}</>}
      </p>
    </AddressDisplay>
  );
};

export default OneTimeAddressDisplay;
